// Based on
https://vueschool.io/articles/vuejs-tutorials/build-an-infinite-scroll-component-using-intersection-observer-api/
<template>
	<div class="observer" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

type ComponentData = {
	observer: null | IntersectionObserver;
	intersecting: boolean;
};
export default defineComponent({
	name: "IntersectionObserver",
	emits: ["intersect-enter", "intersect-exit"],
	props: ["options"],
	data: (): ComponentData => ({
		observer: null,
		intersecting: false,
	}),
	mounted() {
		const options = this.options || {};
		this.observer = new IntersectionObserver(([entry]) => {
			if (entry && entry.isIntersecting) {
				this.$emit("intersect-enter");
			} else if (entry && !entry.isIntersecting) {
				this.$emit("intersect-exit");
			}
		}, options);
		this.observer.observe(this.$el);
	},
	unmounted() {
		if (this.observer !== null) {
			this.observer.disconnect();
		}
	},
});
</script>
